import React from 'react'
import { Alert } from '@material-ui/lab'
import { MessageLoader } from 'components'

type LongWaitDisclaimerLoaderProps = {
  customMessage?: string
}

export const LongWaitDisclaimerLoader: React.FC<LongWaitDisclaimerLoaderProps> = (
  props: LongWaitDisclaimerLoaderProps
) => {
  const message = props.customMessage ?? `The report may take a while to generate. Please be patient.`

  return (
    <MessageLoader>
      <Alert severity={`info`}>
        <div className={`flex flex-col text-lg`}>
          <span>{message}</span>
        </div>
      </Alert>
    </MessageLoader>
  )
}
